import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);
import * as balanceText from 'Lib/balanceText.js';

export namespace JSSlider {
    let setupSlider = () => {
        let sliderContainers = document.querySelectorAll('.js-pr-slider');

        if (!sliderContainers.length) {
            return;
        }

        sliderContainers.forEach((slider, index) => {
            let sliderList = [];
            let sliderParent = slider.closest('.pr-slider__parent');
            sliderParent.classList.add(`pr-slider__parent--${index}`);
            slider.classList.add(`js-slider--${index}`);

            //setup each swiper instance
            let swiper: any = new Swiper(`.js-slider--${index}`, {
                // Optional parameters
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: `.pr-slider__parent--${index} .swiper-pagination`,
                    clickable: true,
                    type: 'bullets',
                    dynamicBullets: true,
                },
                navigation: {
                    nextEl: `.pr-slider__parent--${index} .swiper-button-next`,
                    prevEl: `.pr-slider__parent--${index} .swiper-button-prev`,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                },
                on: {
                    init: function () {
                        balanceText();
                    },
                },
            });

            //push up the swiper data
            sliderList.push(swiper);
            swiper.init();
        });
    };

    export const init = () => {
        setupSlider();
    };
}

/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', JSSlider.init);
} else {
    // `DOMContentLoaded` has already fired
    JSSlider.init();
}
